import { domain } from 'modules/data';
import { useMemo } from 'react';
import { findDocumentFieldState } from 'shared/helpers';

export const useNetSuiteJournalEntryFieldSettings = (documentFields: domain.DocumentField[] | undefined) =>
    useMemo(
        () => ({
            class: findDocumentFieldState(documentFields, 'Class'),
            currency: findDocumentFieldState(documentFields, 'Currency'),
            department: findDocumentFieldState(documentFields, 'Department'),
            exchangeRate: findDocumentFieldState(documentFields, 'ExchangeRate'),
            location: findDocumentFieldState(documentFields, 'Location'),
            memo: findDocumentFieldState(documentFields, 'Memo'),
            postingPeriod: findDocumentFieldState(documentFields, 'PostingPeriod'),
            reference: findDocumentFieldState(documentFields, 'Reference'),
            reversal: findDocumentFieldState(documentFields, 'Reversal'),
            reversalDate: findDocumentFieldState(documentFields, 'ReversalDate'),
            reversalDefer: findDocumentFieldState(documentFields, 'ReversalDefer'),
            transactionDate: findDocumentFieldState(documentFields, 'TransactionDate'),
            itemsAccount: findDocumentFieldState(documentFields, 'ItemsAccount'),
            itemsAmortizationEndDate: findDocumentFieldState(documentFields, 'ItemsAmortizationEndDate'),
            itemsAmortizationResidual: findDocumentFieldState(documentFields, 'ItemsAmortizationResidual'),
            itemsAmortizationSchedule: findDocumentFieldState(documentFields, 'ItemsAmortizationSchedule'),
            itemsAmortizationStartDate: findDocumentFieldState(documentFields, 'ItemsAmortizationStartDate'),
            itemsClass: findDocumentFieldState(documentFields, 'ItemsClass'),
            itemsCreditAmount: findDocumentFieldState(documentFields, 'ItemsCreditAmount'),
            itemsCustomer: findDocumentFieldState(documentFields, 'ItemsCustomer'),
            itemsDebitAmount: findDocumentFieldState(documentFields, 'ItemsDebitAmount'),
            itemsDepartment: findDocumentFieldState(documentFields, 'ItemsDepartment'),
            itemsGrossAmount: findDocumentFieldState(documentFields, 'ItemsGrossAmount'),
            itemsItem: findDocumentFieldState(documentFields, 'ItemsItem'),
            itemsLocation: findDocumentFieldState(documentFields, 'ItemsLocation'),
            itemsMemo: findDocumentFieldState(documentFields, 'ItemsMemo'),
            itemsTaxAccount: findDocumentFieldState(documentFields, 'ItemsTaxAccount'),
            itemsTaxAmount: findDocumentFieldState(documentFields, 'ItemsTaxAmount'),
            itemsTaxCode: findDocumentFieldState(documentFields, 'ItemsTaxCode'),
            itemsTaxRate: findDocumentFieldState(documentFields, 'ItemsTaxRate'),
        }),
        [documentFields]
    );
